export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MIN_CLASSES = 3;

export const PASSWORD_CLASS_REGEX = {
  upper: /[A-Z]/,
  lower: /[a-z]/,
  number: /\d/,
  special: /[^A-Za-z0-9\s]/,
};

export const COMMON_PASSWORDS = new Set(
  [
    '123456', '123456789', 'qwerty', 'password', '12345', 'qwerty123', '1q2w3e', '12345678',
    '111111', '1234567890', '1234567', '123123', 'abc123', '1234', 'password1', 'iloveyou',
    '1q2w3e4r', 'qwertyuiop', 'monkey', 'dragon', '123321', 'letmein', '654321', 'qwe123',
    'welcome', 'admin', 'football', 'sunshine', 'master', '666666', 'qazwsx', 'trustno1',
    '1qaz2wsx', 'shadow', '121212', 'michael', 'superman', '696969', 'batman', 'jordan23',
    'harley', 'ranger', 'jennifer', 'hunter', 'buster', 'thomas', 'tigger', 'robert',
    'soccer', 'fuckyou', 'daniel', 'starwars', 'klaster', 'summer', 'george', 'freedom',
    'cookie', 'whatever', 'ginger', 'nicole', 'jessica', 'amanda', 'joshua', 'maggie',
    'test', 'test123', 'guest', 'changeme', 'temp123', 'temp1234', 'welcome1', 'password123',
    'password1234', 'passw0rd', 'p@ssw0rd', 'p@ssword', 'admin123', 'root', 'toor', 'letmein1',
    'abcd1234', 'abc12345', '11111111', '00000000', '87654321', 'zxcvbnm', 'asdfghjkl',
    'qwerty1', 'qwerty12', 'qwerty1234', '1qaz2wsx3edc', 'baseball', 'basketball', 'donald',
    'access', 'ashley', 'bailey', 'passport', 'internet', 'flower', 'hello', 'hello123',
    'charlie', 'aaaaaa', 'chelsea', 'love', 'loveme', 'pepper', 'princess', 'rockyou',
    'sparky', 'blahblah', 'aa123456', 'zaq12wsx', 'newpassword', 'newpass123', 'default',
    'default123', 'opencashback', 'cashback123', 'senha123', 'senha1234', 'brasil123',
    'brasil2024', 'brasil2025', 'brasil2026', '123mudar', 'mudar123', 'trocar123', 'trocarsenha',
    'usuario123', 'login123', 'account123', 'partner123', 'parceiro123',
  ].map((p) => p.toLowerCase()),
);

export function evaluatePassword(password) {
  const value = password || '';
  return {
    length: value.length >= PASSWORD_MIN_LENGTH,
    upper: PASSWORD_CLASS_REGEX.upper.test(value),
    lower: PASSWORD_CLASS_REGEX.lower.test(value),
    number: PASSWORD_CLASS_REGEX.number.test(value),
    special: PASSWORD_CLASS_REGEX.special.test(value),
    notCommon: value.length > 0 && !COMMON_PASSWORDS.has(value.toLowerCase()),
  };
}

export function isPasswordStrong(password) {
  const result = evaluatePassword(password);
  const classesMet = [result.upper, result.lower, result.number, result.special].filter(Boolean).length;
  return result.length && classesMet >= PASSWORD_MIN_CLASSES && result.notCommon;
}
